(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPeriodoDetailController', SSPeriodoDetailController);

    SSPeriodoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSPeriodo', 'SSAnio'];

    function SSPeriodoDetailController($scope, $rootScope, $stateParams, previousState, entity, SSPeriodo, SSAnio) {
        var vm = this;

        vm.sSPeriodo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSPeriodoUpdate', function(event, result) {
            vm.sSPeriodo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
